import styled from 'styled-components';

const FooterWidget = styled.aside`
  color: ${p => p.theme.colors.footerFont};
  margin-bottom: 50px;
`;

export const FooterWidgetTitle = styled.h4`
  color: ${p => p.theme.colors.white};
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1;
  margin: 0 0 10px 0;
`;

export const FooterWidgetContent = styled.div`
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.81;

  p {
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.81;
  }

  p:last-of-type {
    margin-bottom: 0;
  }
`;

export default FooterWidget;
